import { icons } from 'lucide-react'
import { LucideProps } from 'lucide-react'

const SIZE = 18
const STROKE_WIDTH = 1.5

interface Props extends Omit<LucideProps, 'ref'> {
  name: keyof typeof icons
}
function Icon({ name, ...props }: Props) {
  const LucideIcon = icons[name]

  return <LucideIcon strokeWidth={STROKE_WIDTH} size={SIZE} {...props} />
}

export default Icon
